<template>
  <div>
    <Loading :loading="loading"></Loading>
    <span v-if="!error">Maneno SSO</span>
    <SsoError v-if="error" :message="error"></SsoError>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import SsoError from "@/components/SsoError";
import axios from "axios";
import CryptoJS from "crypto-js";

export default {
  name: "Maneno",
  components: {
    Loading,
    SsoError
  },
  data() {
    return {
      loading: false,
      secretKey: 'Pbt6DND9k5tu7Tdj284-1szLNPEXwcVznFMN4G@UdQtZ7.GEU7!BPy',
      userDataManeno: null,
      userData: null,
      error: null,
    }
  },
  beforeMount() {
    this.loading = true
    const query = this.$route.query;
    if (query.sso) {
      // gelen data çözülüyor
      const decode = decodeURIComponent(atob(query.sso));
      const bytes = CryptoJS.AES.decrypt(decode, this.secretKey).toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(bytes);
      // console.log(this.userData)
      this.ueslmsCheckUser();
    }
  },
  methods: {
    fail(message) {
      this.loading = false;
      this.error = message;
      console.log('Maneno SSO:', message);
    },

    async goManeno() {
      await axios.post('https://manenouk.azurewebsites.net/api/account/v2/uessso',
          {
            username: this.userData.username,
            firstname: this.userData.first_name,
            lastname: this.userData.last_name,
            role: this.userData.role_type,
            schoolid: this.userData.school_id,
            campusid: this.userData.campus_id,
            campusname: this.userData.campus_name,
            schoolname: this.userData.school_name,
            classname: this.userData.class[0]['grade'] + "-" + this.userData.class[0]['branch'],
            classes: this.userData.class.map(x => `${ x.grade + "-" + x.branch }`),
            readinglevel: 1,
            gradelevel: this.userData.class[0]['grade'],
          },
          {
            headers: {
              "Authorization": "37e3718e-f43d-40ad-8e1a-98648a6bacec",
            }
      })
          .then(response => {
            if (response.status !== 200) {
              alert('bir hata olustu')
            }
            // console.log(response)
            window.location.href = response.data
          })
          .catch(response => {
            console.log('ERR', response)
            this.loading = false
          })
    },

    ueslmsCheckUser() {
      axios.post('https://www.ueslms.com/api/v2/maneno/user/check', {user: this.userData})
      // axios.post('https://ueslms.test/api/v2/maneno/user/check', {user: this.userData})
          .then(response => {
            if (response.data.success) {
              this.goManeno()
            } else if (response.data.message) {
              // success:false + message → örn. lisans/yetki reddi. Kullanıcı henüz
              // yok diye create'e düşmek yerine reddi doğrudan gösteriyoruz, çünkü
              // create de aynı kontrolden geçip aynı sebeple reddedilecek.
              this.fail(response.data.message)
            } else {
              this.ueslmsCreate()
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    ueslmsCreate() {
      axios.post('https://www.ueslms.com/api/v2/maneno/user/create', this.userData)
      // axios.post('https://ueslms.test/api/v2/maneno/user/create', this.userData)
          .then(response => {
            if (response.data.success) {
              // user_id ekleniyor
              this.userData.user_idx = response.data.user.user_id;
              // campus_id, ueslms id'si olarak degistiriliyor
              this.userData.campus_idx = response.data.user.campus_id;
              this.goManeno()
            } else {
              this.fail(response.data.message || 'Kullanıcı oluşturulamadı. Lütfen tekrar deneyin.')
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },
  }
}
</script>
